import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { FREE_SHIPPING_THRESHOLD, formatPLN } from "../../config/checkout";

// "X zł to free shipping" line with a thin progress bar. `amount` is the
// products total after discount.
const FreeShippingProgress = ({ amount, sx }) => {
    const missing = Math.max(0, FREE_SHIPPING_THRESHOLD - Number(amount || 0));
    const progress = Math.min(100, (Number(amount || 0) / FREE_SHIPPING_THRESHOLD) * 100);

    return (
        <Box sx={{ width: "100%", ...sx }}>
            <Typography variant="body2" sx={{ mb: 0.75, fontSize: "0.8rem", letterSpacing: "0.03em" }}>
                {missing > 0 ? (
                    <FormattedMessage
                        id="free_shipping_missing"
                        values={{ amount: <b>{formatPLN(missing)}</b> }}
                    />
                ) : (
                    <FormattedMessage id="free_shipping_reached" />
                )}
            </Typography>
            <LinearProgress
                variant="determinate"
                value={progress}
                aria-hidden="true"
                sx={{
                    height: 3,
                    borderRadius: 0,
                    bgcolor: "divider",
                    "& .MuiLinearProgress-bar": { bgcolor: missing > 0 ? "text.primary" : "#8A7356" },
                }}
            />
        </Box>
    );
};

export default FreeShippingProgress;
